import { RouteConfig } from "vue-router";
import Layout from '@/layout/index.vue';

const mpsManagement: RouteConfig[] = [
  {
    path: '/',
    component: Layout,
    meta: {
      roles: ['mps']
    },
    children: [
      {
          path: 'commission',
          name: 'commissionManagement',
          meta: {
            icon: 'commission',
            title: 'mpsManagement',
            roles: ['mps']
          },
          component: () => import(/* webpackChunkName: "stuManagement" */ '@/views/mps-center/mps-management.vue'),
      },
    ]
  }
]
export default mpsManagement
